import { Cell } from "@tanstack/react-table";
import { IDistributionOrder } from "domain/Inventory/Models/IDistributionOrder";
import { IDistributionOrderSummary } from "domain/Inventory/Models/IDistributionOrderSummary";
import { SBBox } from "modules/Commons";
import { SBNewTable } from "modules/Commons/SBDataDisplays/SBTable/SBNewTable";
import { useGlobalInventoryContext } from "modules/Inventory/components/SBGlobalInventoryInfoModal";
import React, { forwardRef, useContext, useState } from "react";
import { DistributionOrderSummarization } from "../DistributionOrderSummarization";
import { useDistributionOrderHeaders } from "./useDistributionOrderHeaders";

import { IDistributionOrderTableProps } from "./models/IDistributionOrderTableProps";

const DistributionOrderTable = forwardRef(
	({ title, rows, containerHeight, summary, onScroll }: IDistributionOrderTableProps, ref: any) => {
		const { headers } = useDistributionOrderHeaders();
		const [selectedItems, setSelectedItems] = useState<IDistributionOrder[]>([]);
		const { openMenuByClientID, isOpen } = useContext(useGlobalInventoryContext);

		const handleClick = (cell: Cell<IDistributionOrder, any>) => {
			if (cell.column.id === "inventory") {
				openMenuByClientID(cell.row.original.productClientID, cell.row.original.destinationStoreClientID);
			}
		};

		return (
			<SBBox>
				<DistributionOrderSummarization
					summary={summary}
					selectedItems={selectedItems}
				/>
				<SBBox width={isOpen ? "50vw" : "100%"} style={{ transition: "all 0.25s ease", marginTop: "1rem" }}>
					<SBNewTable
						ref={ref}
						hasSelection
						virtualize
						title={title}
						startRows={rows}
						defaultColumns={headers}
						onClick={handleClick}
						onSelect={(_, indices) =>
							setSelectedItems(
								(indices as string[]).map((i) => rows[+i]),
							)
						}
						containerHeight={containerHeight}
						totalCount={summary?.totalCount}
						onScroll={onScroll}
					/>
				</SBBox>
			</SBBox>
		);
	},
);

export default DistributionOrderTable;
